<template>
  <div>
    <div class="row">
      <div class="col-sm-6">
        <div class="card card h-90">
          <div class="card-body">
            <h5 class="card-title">Divulgações</h5>
            <hr class="divider" />
            <p class="card-text">Divulgação dos resultados das pesquisas.</p>
            <a href="/worker/disclosures" class="btn btn-worker">Visualizar</a>
          </div>
        </div>
      </div>
      <div class="col-sm-6">
        <div class="card card h-90">
          <div class="card-body">
            <h5 class="card-title">Planos de Ação</h5>
            <hr class="divider" />
            <p class="card-text">
              Planos de Ação atribuídos a você sobre pesquisas realizadas.
            </p>
            <a href="/worker/actionPlans" class="btn btn-worker">Visualizar</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {},
  mounted: function () {
    const self = this;
  },
};
</script>
<style scoped>
.btn-worker {
  color: #424241;
  border-radius: 0.25rem;
  border: 2px solid #26b283;
  background: linear-gradient(to right, #26b283, #26b283);
  background-repeat: no-repeat;
  background-size: 0 100%;
  transition: background-size 0.6s 0s;
}

.btn-worker:hover {
  color: #fff;
  background-size: 100% 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Worker/Home.vue